module.exports = __webpack_public_path__ + "static/background-books-2b8a6ed33a28560a03230c10f3c1eaf8.jpg";